import React from 'react';

import { Routes } from 'routes';
import { BB_IMAGE_URL, BB_URL, Branding } from 'common/env';

export const Footer = () => {
    return (
        <footer className="pb-[calc(64px+env(safe-area-inset-bottom))] sm:pb-0">
            <div className="flex sm:flex-row flex-col gap-6 pb-3 pt-1">
                <div className="self-start" style={{ minWidth: '141px', maxWidth: '141px' }}>
                    <a target="_blank" href={BB_URL}>
                        <img src={BB_IMAGE_URL} />
                    </a>
                </div>
                <div className="text-xs text-grey-medium gap-2 flex flex-col pr-4">
                    <div className="flex gap-2 text-grey-2 md:flex-row flex-col">
                        <p>
                            © 1999 - {new Date().getFullYear()} {Branding}. All Rights Reserved.
                        </p>
                        <div className="block md:flex md:flex-row gap-2">
                            <a
                                target="_blank"
                                className="font-semibold"
                                href={Routes.PrivacyPolicy}
                            >
                                {Branding} Privacy Policy
                            </a>
                            <span className="text-grey-light px-1">|</span>
                            <a target="_blank" className="font-semibold" href={Routes.TermsOfUse}>
                                Terms of Use{' '}
                            </a>
                        </div>
                    </div>

                    <p>
                        <strong>Need help?</strong> Call our Customer Support Team at{' '}
                        <a className="font-semibold" href="tel:800-727-4715">
                            800-727-4715
                        </a>{' '}
                        (Option 3)
                    </p>
                    <p>
                        The merchants represented are not sponsors of {Branding} or otherwise
                        affiliated with {Branding}. The Logos and other identifying marks on this
                        website are trademarks of and owned by each represented company and/or its
                        affiliates. Please visit each company’s website for additional terms and
                        conditions.
                    </p>
                </div>
            </div>
        </footer>
    );
};
